import { trpc } from "../../../lib/api/trpc";
import type { Document } from "../../../types/documents";

/**
 * Hook to fetch a single document by ID
 */
export const useDocument = (id: string) => {
  // @ts-ignore - Type checking for trpc.documents property
  const { data, isLoading, isError, error, refetch } =
    trpc.documents.get.useQuery(
      { id },
      { enabled: !!id }, // Only run query if ID is provided
    );

  return {
    document: data as Document | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
